import {EventEmitter, Injectable, Output} from '@angular/core';
import {MainPageDetailModel} from '../models/plans.model';

@Injectable()

export class EventsManager {
  @Output() public showHideSubheader: EventEmitter<any> = new EventEmitter();
  @Output() public officeUpdate: EventEmitter<any> = new EventEmitter();
  @Output() public planDetailUpdate: EventEmitter<any> = new EventEmitter();
  @Output() public levelSelected: EventEmitter<any> = new EventEmitter();
  @Output() public feeScheduleUpdate: EventEmitter<any> = new EventEmitter();
  @Output() public showPaymentScreen: EventEmitter<any> = new EventEmitter();
  @Output() public showSuccessScreen: EventEmitter<any> = new EventEmitter();
  @Output() public togglePrimary: EventEmitter<any> = new EventEmitter();
  @Output() public acceptMemberAgreement: EventEmitter<any> = new EventEmitter();
  @Output() public setPurchaseStep: EventEmitter<any> = new EventEmitter();
  @Output() public loadingState: EventEmitter<any> = new EventEmitter();
  @Output() public getwWhoIsPrimary: EventEmitter<any> = new EventEmitter();
  @Output() public memberCountUpdate: EventEmitter<any> = new EventEmitter();
  @Output() public updateForm: EventEmitter<any> = new EventEmitter();
  @Output() public hasMinor: EventEmitter<any> = new EventEmitter();
  @Output() public taxPercUpdated: EventEmitter<any> = new EventEmitter();
  @Output() public smsTokenEntered: EventEmitter<any> = new EventEmitter();
  @Output() public setNewTheme: EventEmitter<any> = new EventEmitter();
  @Output() public setNewCustTheme: EventEmitter<any> = new EventEmitter();

  public docOrgId: string = '';
  public orgId: string = '';
  public officeInfo?: MainPageDetailModel = undefined;
  public planDetailInfo: any = {};
  public selectedLevel: any = {};
  private _feeScheduleInfo: any = {};
  public showLoading: boolean = false;
  public legalLanguage: any = {};
  public themeId: string = '';

  public subHeaderShowHide(evt: boolean) {
    this.showHideSubheader.emit(evt);
  }

  public getOfficeInfo() {
    let office: any = {};
    if (this.officeInfo?.name) {
      office = this.officeInfo;
    } else if (sessionStorage['office']) {
      office = JSON.parse(sessionStorage['office']);
      this.officeInfo = office;
    }

    return office;
  }

  public getFeeScheduleInfo() {
    if (!this._feeScheduleInfo.pageName) {
      this.setFeeScheduleInfo({});
    }

    return this._feeScheduleInfo;
  }

  public setOfficeInfo(office: MainPageDetailModel) {
    sessionStorage['office'] = JSON.stringify(office);
    this.officeInfo = office;
    this.officeUpdate.emit(office);
  }

  public setPlanDetails(details: any) {
    sessionStorage['planDetails'] = JSON.stringify(details);
    this.planDetailInfo = details;
    this.planDetailUpdate.emit();
  }

  public setLevelSelected(level: any) {
    sessionStorage['level'] = JSON.stringify(level);
    this.selectedLevel = level;
    this.levelSelected.emit();
  }

  public setFeeScheduleInfo(feeSchedule: any) {
    if (this._feeScheduleInfo.practiceId) {
      this._feeScheduleInfo = feeSchedule;
    } else if (sessionStorage['fees']) {
      this._feeScheduleInfo = JSON.parse(sessionStorage['fees']);
    }
    this.feeScheduleUpdate.emit(this._feeScheduleInfo);
  }

  public setLoadingState(state: boolean) {
    this.showLoading = state;
    this.loadingState.emit(this.showLoading);
  }

  public setLegalLanguage(data: any) {
    this.legalLanguage = data ?? {};
  }

  public setThemeId(themeId: string) {
    this.themeId = themeId;
  }
}
